module.exports = __webpack_public_path__ + "static/media/FooterLight.c0fe17c8.svg";